import { render, staticRenderFns } from "./PlanButton.vue?vue&type=template&id=0f12266b"
import script from "./PlanButton.vue?vue&type=script&lang=js"
export * from "./PlanButton.vue?vue&type=script&lang=js"
import style0 from "./PlanButton.vue?vue&type=style&index=0&id=0f12266b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports